import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiPlus, FiMoreVertical } from 'react-icons/fi';
import { weeklyPlan } from '../data/mockData';

const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
const meals = ['breakfast', 'lunch', 'dinner'];

export const MealBoard = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="h-full flex flex-col"
    >
      <header className="mb-6 flex justify-between items-end">
        <div>
          <h1 className="text-2xl font-bold text-steel-900 tracking-tight">Meal Board</h1>
          <p className="text-steel-500">Current Cycle: Week 42</p>
        </div>
        <button className="bg-steel-900 hover:bg-steel-800 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2 shadow-sm">
          <SafeIcon icon={FiPlus} /> Auto-Fill
        </button>
      </header>

      <div className="panel flex-1 overflow-x-auto bg-cream-50">
        <div className="min-w-[800px] h-full flex flex-col">
          {/* Header Row */}
          <div className="grid grid-cols-8 border-b border-steel-200 bg-white sticky top-0 z-10">
            <div className="p-4 text-xs font-mono text-steel-400 flex items-center justify-center border-r border-steel-100">
              SLOT
            </div>
            {days.map(day => (
              <div key={day} className="p-4 text-center font-medium text-steel-700 border-r border-steel-100 last:border-r-0">
                {day}
              </div>
            ))}
          </div>

          {/* Grid Body */}
          <div className="flex-1 flex flex-col">
            {meals.map((mealType) => (
              <div key={mealType} className="grid grid-cols-8 flex-1 border-b border-steel-100 last:border-b-0 min-h-[120px]">
                {/* Time Slot Label */}
                <div className="p-4 border-r border-steel-100 flex items-center justify-center bg-white">
                  <span className="text-xs font-mono text-steel-500 uppercase rotate-180" style={{ writingMode: 'vertical-rl' }}>
                    {mealType}
                  </span>
                </div>
                
                {/* Day Cells */}
                {days.map(day => {
                  const mealData = weeklyPlan[day]?.[mealType];
                  return (
                    <div key={`${day}-${mealType}`} className="p-2 border-r border-steel-100 last:border-r-0 hover:bg-steel-50/50 transition-colors group relative">
                      {mealData ? (
                        <div className="h-full bg-white border border-steel-200 rounded p-2 shadow-sm flex flex-col group-hover:border-tomato-300 transition-colors cursor-pointer">
                          <img src={mealData.image} alt={mealData.title} className="w-full h-12 object-cover rounded-sm mb-2" />
                          <div className="text-xs font-medium text-steel-900 line-clamp-2 leading-tight">
                            {mealData.title}
                          </div>
                          <div className="mt-auto pt-2 flex justify-between items-center text-[10px] font-mono text-steel-400">
                             <span>{mealData.cals}c</span>
                             <SafeIcon icon={FiMoreVertical} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                          </div>
                        </div>
                      ) : (
                        <div className="h-full border-2 border-dashed border-steel-200 rounded flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer hover:border-tomato-300 hover:bg-tomato-50">
                          <SafeIcon icon={FiPlus} className="text-steel-400 hover:text-tomato-500" />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
};